import { v4 } from 'uuid';
import { bidAveragePlayAggro } from './ohHell/expert/bidAggroPlayAggro.js';
import { bidAveragePlayLeastWinningCard } from './ohHell/expert/bidAggroPlayLeastWinningCard.js';
import { bidAveragePlayRandom } from './ohHell/expert/bidAveragePlayRandom.js';
import { ExpertIds } from './ohHell/expert/shared.js';
import { OhHellCmdType } from './ohHell/OhHell.js';
import { GameRuleSets } from './shared/index.js';
const getOhHellDealCards = (state) => ({
    playerId: state.currentRound.dealerPlayerId,
});
const gameExpertCommandRequestRouter = {
    [GameRuleSets.Base]: undefined,
    [GameRuleSets.WinThisGame]: undefined,
    [GameRuleSets.OhHell]: {
        [ExpertIds.thirsty]: {
            [OhHellCmdType.DealCards]: getOhHellDealCards,
            [OhHellCmdType.PlaceBid]: bidAveragePlayRandom.getBid,
            [OhHellCmdType.PlayCard]: bidAveragePlayRandom.getPlayerCard,
            [OhHellCmdType.Start]: undefined,
            [OhHellCmdType.GetPlayerState]: undefined,
        },
        [ExpertIds.cautious]: {
            [OhHellCmdType.DealCards]: getOhHellDealCards,
            [OhHellCmdType.PlaceBid]: bidAveragePlayLeastWinningCard.getBid,
            [OhHellCmdType.PlayCard]: bidAveragePlayLeastWinningCard.getPlayerCard,
            [OhHellCmdType.Start]: undefined,
            [OhHellCmdType.GetPlayerState]: undefined,
        },
        [ExpertIds.random]: {
            [OhHellCmdType.DealCards]: getOhHellDealCards,
            [OhHellCmdType.PlaceBid]: bidAveragePlayAggro.getBid,
            [OhHellCmdType.PlayCard]: bidAveragePlayAggro.getPlayerCard,
            [OhHellCmdType.Start]: undefined,
            [OhHellCmdType.GetPlayerState]: undefined,
        },
    },
};
export const requestExpertCommand = (game, commandRequest) => {
    const gameRuleSetName = game.gameRuleSetName;
    const expertPlayerId = commandRequest.computerPlayerId;
    const { commandName } = commandRequest;
    const expertRouter = gameExpertCommandRequestRouter[gameRuleSetName];
    const expertRequestRouter = expertRouter && expertRouter[expertPlayerId];
    const requestHandler = expertRequestRouter && expertRequestRouter[commandName];
    if (!requestHandler) {
        return undefined;
    }
    const cmdData = requestHandler(game.gameState);
    return {
        player: commandRequest.player,
        cmdId: v4(),
        gameId: game.gameId,
        gameRuleSetName,
        cmdType: commandName,
        cmdData,
    };
};
//# sourceMappingURL=requestExpertCommand.js.map